import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {AlertService} from '../../shared/alert/alert.service';
import * as _ from 'lodash';

declare const _: any;

@Component({
    selector: 'weekly-summary',
    templateUrl: './weekly-summary.component.html',
    styleUrls: ['./weekly-summary.component.css']
})
export class WeeklySummaryComponent implements OnInit {

    _: any;
    @Input() data1: any;
    @Output() onMouseOver: EventEmitter<any>;
    @Output() onMouseOut: EventEmitter<any>;
    @Output() onClick: EventEmitter<any>;

    data = [];

    constructor(private alertService: AlertService) {
        this.onMouseOver = new EventEmitter();
        this.onMouseOut = new EventEmitter();
        this.onClick = new EventEmitter();
        this._ = _;
        this.data = [];
    }

    ngOnInit() {
        const self = this;
        var params = {timePeriod: 'w'};
        this.alertService.getAlertsSummary(params).subscribe(function(alerts){
            self.data = alerts;
        });
    }

    onThreatMouseOver(evt) {
        this.onMouseOver.emit(evt);
    }

    onThreatMouseOut(evt) {
        this.onMouseOut.emit(evt);
    }

    onThreatClick(evt) {
        this.onClick.emit(evt.type);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/weekly-summary/weekly-summary.component.ts